var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { v4 as uuid } from 'uuid';
import { ClickableDate } from './ClickableDate';
import { NonClickableDate } from './NonClickableDate';
import { Header } from './Header';
import { getSimpleDateFromString, getSimpleDateFromTimestamp, } from '../datelogic/simpledate';
import { SimpleCalendar } from '../datelogic/simplecalendar';
var Calendar = /** @class */ (function (_super) {
    __extends(Calendar, _super);
    function Calendar(props) {
        var _this = _super.call(this, props) || this;
        _this.clickableDateRef = React.createRef();
        _this.prevMonthButtonElementRef = React.createRef();
        _this.nextMonthButtonElementRef = React.createRef();
        _this.focusTrap = function (event) {
            var _a, _b, _c, _d, _e, _f;
            var activeElement = document.activeElement;
            if (event.key === 'Tab') {
                event.preventDefault();
                if (event.shiftKey) {
                    if (activeElement === _this.clickableDateRef.current) {
                        (_a = _this.nextMonthButtonElementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                        _this.setState({ isFocusingHeader: true });
                    }
                    if (activeElement === _this.nextMonthButtonElementRef.current) {
                        (_b = _this.prevMonthButtonElementRef.current) === null || _b === void 0 ? void 0 : _b.focus();
                    }
                    if (activeElement === _this.prevMonthButtonElementRef.current) {
                        (_c = _this.clickableDateRef.current) === null || _c === void 0 ? void 0 : _c.focus();
                        _this.setState({ isFocusingHeader: false });
                        _this.forceUpdate();
                    }
                }
                else {
                    if (activeElement === _this.clickableDateRef.current) {
                        (_d = _this.prevMonthButtonElementRef.current) === null || _d === void 0 ? void 0 : _d.focus();
                        _this.setState({ isFocusingHeader: true });
                    }
                    if (activeElement === _this.prevMonthButtonElementRef.current) {
                        (_e = _this.nextMonthButtonElementRef.current) === null || _e === void 0 ? void 0 : _e.focus();
                    }
                    if (activeElement === _this.nextMonthButtonElementRef.current) {
                        (_f = _this.clickableDateRef.current) === null || _f === void 0 ? void 0 : _f.focus();
                        _this.setState({ isFocusingHeader: false });
                        _this.forceUpdate();
                    }
                }
            }
        };
        _this.state = {
            calendar: new SimpleCalendar(getSimpleDateFromString(props === null || props === void 0 ? void 0 : props.selectedDate), props.locale),
            isFocusingHeader: false,
        };
        _this.datepickerId = "ffe-calendar-".concat(uuid());
        _this.keyDown = _this.keyDown.bind(_this);
        _this.mouseClick = _this.mouseClick.bind(_this);
        _this.nextMonth = _this.nextMonth.bind(_this);
        _this.previousMonth = _this.previousMonth.bind(_this);
        _this.navigateToMonthYear = _this.navigateToMonthYear.bind(_this);
        _this.renderDate = _this.renderDate.bind(_this);
        _this.renderWeek = _this.renderWeek.bind(_this);
        _this.renderDay = _this.renderDay.bind(_this);
        return _this;
    }
    /* eslint-disable react/no-did-update-set-state */
    Calendar.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.selectedDate !== this.props.selectedDate) {
            this.setState({
                calendar: new SimpleCalendar(getSimpleDateFromString(this.props.selectedDate), this.props.locale),
            }, this.forceUpdate);
        }
    };
    Calendar.prototype.shouldComponentUpdate = function (nextProps) {
        return nextProps.selectedDate !== this.props.selectedDate;
    };
    Calendar.prototype.keyDown = function (event) {
        var _a, _b;
        var calendar = this.state.calendar;
        var scrollableEvents = [
            'PageUp',
            'PageDown',
            'End',
            'Home',
            'ArrowLeft',
            'ArrowUp',
            'ArrowRight',
            'ArrowDown',
        ];
        if (!scrollableEvents.includes(event.key)) {
            event.preventDefault();
        }
        switch (event.key) {
            case 'Enter':
                if (calendar.isDateWithinDateRange(calendar.focusedDate)) {
                    calendar.selectFocusedDate();
                    this.props.onDatePicked(calendar.selected());
                }
                event.preventDefault();
                break;
            case 'Escape':
                (_b = (_a = this.props).escKeyHandler) === null || _b === void 0 ? void 0 : _b.call(_a, event);
                break;
            case 'Tab':
                break;
            case 'PageUp':
                if (event.altKey) {
                    calendar.previousYear();
                }
                else {
                    calendar.previousMonth();
                }
                break;
            case 'PageDown':
                if (event.altKey) {
                    calendar.nextYear();
                }
                else {
                    calendar.nextMonth();
                }
                break;
            case 'End':
                calendar.lastDateOfMonth();
                break;
            case 'Home':
                calendar.firstDateOfMonth();
                break;
            case 'ArrowLeft':
                calendar.previousDay();
                break;
            case 'ArrowUp':
                calendar.previousWeek();
                break;
            case 'ArrowRight':
                calendar.nextDay();
                break;
            case 'ArrowDown':
                calendar.nextWeek();
                break;
            default:
                return;
        }
        this.forceUpdate();
    };
    Calendar.prototype.mouseClick = function (date) {
        var pickedDate = getSimpleDateFromTimestamp(date.timestamp);
        if (this.state.calendar.isDateWithinDateRange(pickedDate)) {
            this.state.calendar.selectTimestamp(date.timestamp);
            this.props.onDatePicked(this.state.calendar.selected());
        }
    };
    Calendar.prototype.nextMonth = function (evt) {
        evt.preventDefault();
        this.state.calendar.nextMonth();
        this.forceUpdate();
    };
    Calendar.prototype.previousMonth = function (evt) {
        evt.preventDefault();
        this.state.calendar.previousMonth();
        this.forceUpdate();
    };
    Calendar.prototype.renderDate = function (calendarButtonState, index) {
        var calendar = this.state.calendar;
        if (calendarButtonState.isNonClickableDate) {
            return (React.createElement(NonClickableDate, { key: calendarButtonState.dayInMonth, date: { timestamp: calendarButtonState.timestamp } }));
        }
        return (React.createElement(ClickableDate, { calendarButtonState: calendarButtonState, month: calendar.focusedMonth, year: calendar.focusedYear, headers: "header__".concat(this.datepickerId, "__").concat(index), key: calendarButtonState.timestamp, onClick: this.mouseClick, locale: this.props.locale, dateButtonRef: calendarButtonState.isFocus
                ? this.clickableDateRef
                : undefined, isFocusingHeader: this.state.isFocusingHeader, focusOnMount: this.props.focusOnMount }));
    };
    Calendar.prototype.renderWeek = function (week) {
        return (React.createElement("tr", { key: "week-".concat(week.number), role: "presentation" }, week.dates.map(this.renderDate)));
    };
    Calendar.prototype.renderDay = function (day, index) {
        return (React.createElement("th", { "aria-label": day.name, className: "ffe-calendar__weekday", id: "header__".concat(this.datepickerId, "__").concat(index), key: day.name },
            React.createElement("span", { title: day.name }, day.shortName)));
    };
    /**
     * Navigate to a specific month and year
     */
    Calendar.prototype.navigateToMonthYear = function (month, year) {
        var calendar = this.state.calendar;
        var currentMonth = calendar.focusedDate.month + 1; // 1-indexed month
        var currentYear = calendar.focusedYear;
        // Calculate how many months to move based on current and target date
        var monthsDiff = (year - currentYear) * 12 + (month - currentMonth);
        if (monthsDiff < 0) {
            // Go backward
            for (var i = 0; i > monthsDiff; i--) {
                calendar.previousMonth();
            }
        }
        else if (monthsDiff > 0) {
            // Go forward
            for (var i = 0; i < monthsDiff; i++) {
                calendar.nextMonth();
            }
        }
        this.forceUpdate();
    };
    Calendar.prototype.render = function () {
        var _this = this;
        var calendar = this.state.calendar;
        /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
        return (React.createElement("div", { role: "dialog", "aria-modal": true, "aria-labelledby": "".concat(this.datepickerId, "-title"), className: "ffe-default-mode" },
            React.createElement("div", { className: this.props.calendarClassName || 'ffe-calendar', role: "application", onKeyDown: this.focusTrap },
                React.createElement(Header, { datepickerId: this.datepickerId, month: calendar.focusedMonth, nextMonthHandler: this.nextMonth, nextMonthLabel: calendar.nextName, previousMonthHandler: this.previousMonth, previousMonthLabel: calendar.previousName, year: calendar.focusedYear, prevMonthButtonElement: this.prevMonthButtonElementRef, nextMonthButtonElement: this.nextMonthButtonElementRef, monthNumber: calendar.focusedDate.month + 1, locale: this.props.locale, dropdownCaption: this.props.dropdownCaption, onMonthYearChange: function (month, year) { return _this.navigateToMonthYear(month, year); }, minDate: this.props.minDate, maxDate: this.props.maxDate }),
                React.createElement("table", { className: "ffe-calendar__grid", onKeyDown: this.keyDown, role: "presentation" },
                    React.createElement("thead", null,
                        React.createElement("tr", null, calendar.dayNames.map(this.renderDay))),
                    React.createElement("tbody", null, calendar.visibleDates.map(this.renderWeek))))));
        /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */
    };
    return Calendar;
}(Component));
export { Calendar };
